<button
  class="flex justify-center items-center text-xs w-max chip"
  [class.active]="active"
  matRipple
  (click)="clickChip()"
>
  <ng-content></ng-content>
</button>
